import React from 'react';
import { SvgProps, useDefaultColor } from '../core';

const TRANSFORM = {
  up: 'rotate(180deg)',
  down: 'rotate(0deg)',
  left: 'rotate(90deg)',
  right: 'rotate(-90deg)',
};

interface ArrowInCircleProps extends SvgProps {
  direction?: 'left' | 'right' | 'up' | 'down';
  rotateDimensions?: boolean;
}

const ArrowInCircle: React.FC<ArrowInCircleProps> = ({
  color,
  width = 32,
  height = 32,
  style,
  className,
  direction = 'down',
  rotateDimensions = false,
}) => {
  const resolvedColor = useDefaultColor(color);
  const swapWidthHeight =
    !rotateDimensions && (direction === 'left' || direction === 'right');

  return (
    <svg
      width={swapWidthHeight ? height : width}
      height={swapWidthHeight ? width : height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...(style ?? {}), transform: TRANSFORM[direction] }}
      className={className}
    >
      <path
        d="M21.121 15.464L17 19.586V9a1 1 0 00-2 0v10.586l-4.121-4.121a.999.999 0 10-1.414 1.414l5.657 5.657a.98.98 0 00.879.259c.31.055.64-.02.88-.26l5.656-5.656a.999.999 0 000-1.414 1.002 1.002 0 00-1.416-.001zM16 0C7.164 0 0 7.163 0 16s7.164 16 16 16 16-7.164 16-16S24.837 0 16 0zm0 30C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14z"
        fill={resolvedColor}
      />
    </svg>
  );
};

export default ArrowInCircle;
